export class Jobform {
  constructor (settings = {}) {
    this.settings = {
      ...settings,
      selectors: {
        parentFieldset: '.powermail_fieldset.doc-uploads',
        addButton: '.form__add-button',
        uploadFieldWrapper: '.powermail_fieldwrap_type_file'
      }
    }

    this.uploadFieldGroups = []
    this.uploadFieldVisibility = []
  }

  init () {
    const { selectors } = this.settings
    const parentFieldset = document.querySelector(selectors.parentFieldset)

    if (parentFieldset !== null) {
      this.uploadFieldGroups = parentFieldset.querySelectorAll(selectors.uploadFieldWrapper)
      if (this.uploadFieldGroups.length === 0) return

      this.initUploadFields()
      this.insertAddButton(parentFieldset)
      this.showNextField()
    }
  }

  initUploadFields () {
    // alle File Upload Felder und dazugehörigen Beschreibungstexte ausblenden
    for (let i = 0; i < this.uploadFieldGroups.length; i++) {
      const element = this.uploadFieldGroups[i]
      element.setAttribute('style', 'display: none')
      element.previousSibling.setAttribute('style', 'display: none;')

      this.uploadFieldVisibility.push({
        element,
        visible: false
      })
    }
  }

  insertAddButton (parentElement) {
    parentElement.insertAdjacentHTML('beforeend', '<button class="btn btn--secondary form__add-button" type="button">Weitere Felder einblenden</button>')

    const addButton = document.querySelector(this.settings.selectors.addButton)
    if (addButton) {
      addButton.addEventListener('click', () => this.showNextField())
    }
  }

  removeAddButton () {
    const addButton = document.querySelector(this.settings.selectors.addButton)
    if (addButton) {
      addButton.removeEventListener('click', () => this.showNextField())
      addButton.remove()
    }
  }

  showNextField () {
    if (this.uploadFieldVisibility.length === 0) return

    for (let i = 0; i < this.uploadFieldVisibility.length; i++) {
      if (this.uploadFieldVisibility[i].visible === false) {
        // get element and description and show
        this.uploadFieldVisibility[i].visible = true
        this.uploadFieldVisibility[i].element.setAttribute('style', 'display: block')
        this.uploadFieldVisibility[i].element.previousSibling.setAttribute('style', 'display: block;')

        if (i === this.uploadFieldVisibility.length - 1) {
          this.removeAddButton()
        }

        return
      }
    }
  }
}

export default Jobform
